var orderBy = require('./orderBy')

var sortBy = orderBy

module.exports = sortBy
